import React from "react";
import Programs from "../components/sections/Programs";

const ProgramsPage = () => (
  <main className="pt-24 pb-10 min-h-screen" data-testid="programs-page">
    <div className="text-center max-w-2xl mx-auto px-4 pt-8">
      <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Programs</span>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold mt-2 mb-4">Our learning programs</h1>
      <p className="text-[color:var(--text-secondary)]">
        Six complementary streams that build every child's day at Innovative Preschool.
      </p>
    </div>
    <Programs />
  </main>
);

export default ProgramsPage;
